(function () {
  document.querySelectorAll('[data-vp-root]').forEach(init);

  function init(root) {
    var product = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var upsells = [];
    try { upsells = JSON.parse(root.querySelector('[data-upsell-json]').textContent); } catch (e) {}
    var PROMO = root.dataset.promo === 'true';
    var FREE = (parseInt(root.dataset.free, 10) || 0) * 100;
    var gradIndex = parseInt(root.dataset.gradIndex, 10);
    var currency = root.dataset.currency || 'EUR';
    var fmt = function (c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: currency }); };
    var gnum = function (s) { if (s == null) return null; var n = parseFloat(String(s).replace('+', '').replace(',', '.')); return isNaN(n) ? null : n; };
    var variant = product.variants.find(function (v) { return String(v.id) === root.dataset.initialVariant; }) || product.variants[0];
    var sel = variant.options.slice();
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    function match(opts) { return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }

    /* ---- Entrega ---- */
    var HOL = ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'];
    function isBiz(d) {
      var w = d.getDay();
      if (w === 0 || w === 6) return false;
      var k = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      return HOL.indexOf(k) < 0;
    }
    function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; }
    function madrid() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' })); }
    function sameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
    function dayLabel(d, now) {
      if (sameDay(d, now)) return 'Hoy';
      var t = new Date(now); t.setDate(t.getDate() + 1);
      if (sameDay(d, t)) return 'Mañana';
      return d.toLocaleDateString('es-ES', { weekday: 'short' }).replace('.', '') + ' ' + d.getDate();
    }
    function shipping() {
      var now = madrid();
      var today = isBiz(now) && now.getHours() < 14;
      var out = today ? new Date(now) : addBiz(now, 1);
      var a = addBiz(out, 1), b = addBiz(out, 2);
      var o = $('[data-ship-out]'), e = $('[data-ship-eta]'), c = $('[data-cutoff]');
      if (o) o.textContent = dayLabel(out, now);
      if (e) {
        var la = dayLabel(a, now), lb = dayLabel(b, now);
        e.textContent = (la.indexOf(' ') > 0 && a.getMonth() === b.getMonth()) ? la + '–' + b.getDate() : la + ' – ' + lb;
      }
      if (c) {
        if (today) {
          var end = new Date(now); end.setHours(14, 0, 0, 0);
          var s = Math.max(0, Math.floor((end - now) / 1000));
          var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
          c.innerHTML = 'Pídelo en <b>' + (h ? h + ' h ' : '') + m + ' min</b> y sale hoy';
        } else {
          c.innerHTML = 'Pídelo ahora y sale el <b>' + out.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric' }) + '</b>';
        }
      }
    }
    shipping();
    setInterval(shipping, 30000);

    /* ---- Opciones ---- */
    function updateOptions() {
      $$('[data-option-index]').forEach(function (fs) {
        var i = +fs.dataset.optionIndex;
        fs.querySelectorAll('input').forEach(function (inp) {
          var opts = sel.slice(); opts[i] = inp.value;
          var v = match(opts);
          inp.checked = inp.value === sel[i];
          inp.closest('.vp__pill').classList.toggle('is-unavailable', !v || !v.available);
        });
        var lab = fs.querySelector('[data-selected-value]');
        if (lab) lab.textContent = sel[i];
      });
    }

    /* ---- 2ª gafa ---- */
    var picked = null;
    function secondPrice(p) {
      if (!PROMO || !variant) return p;
      return p - Math.round(Math.min(p, variant.price) / 2);
    }
    function resolveUpsells() {
      var wrap = $('[data-upsell-wrap]');
      if (!wrap) return;
      var g = gradIndex >= 0 ? gnum(sel[gradIndex]) : null;
      var shown = 0;
      $$('[data-upsell]').forEach(function (el) {
        var u = upsells.find(function (x) { return String(x.id) === el.dataset.upsell; });
        var v = u ? u.variants.find(function (x) { return x.a && (g === null || x.g === g); }) : null;
        if (!v) {
          el.hidden = true; el.dataset.variant = '';
          if (picked === el) picked = null;
          el.setAttribute('aria-pressed', 'false');
          return;
        }
        el.hidden = false; shown++;
        el.dataset.variant = v.id; el.dataset.price = v.p;
        el.querySelector('[data-upsell-sub]').textContent = g !== null ? 'Graduación ' + v.t : (v.t && v.t !== 'Default Title' ? v.t : '');
      });
      wrap.hidden = shown === 0;
      paintUpsells();
    }
    function paintUpsells() {
      $$('[data-upsell]').forEach(function (el) {
        if (el.hidden || !el.dataset.price) return;
        var p = +el.dataset.price, np = secondPrice(p);
        el.querySelector('[data-upsell-price]').innerHTML = np < p ? '<s>' + fmt(p) + '</s><em>' + fmt(np) + '</em>' : fmt(p);
        var on = picked === el;
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
        el.querySelector('[data-upsell-cta]').textContent = on ? 'Añadida ✓' : 'Añadir';
      });
    }

    function units() {
      var list = [];
      if (!variant) return list;
      list.push(variant.price);
      if (picked && !picked.hidden && picked.dataset.variant) list.push(+picked.dataset.price);
      return list;
    }
    function calc(list) {
      var full = list.reduce(function (a, b) { return a + b; }, 0);
      var disc = 0;
      if (PROMO) {
        var sorted = list.slice().sort(function (a, b) { return a - b; });
        var k = Math.floor(list.length / 2);
        for (var i = 0; i < k; i++) disc += Math.round(sorted[i] / 2);
      }
      return { full: full, total: full - disc, disc: disc, n: list.length };
    }

    function render() {
      variant = match(sel);
      var atc = $('[data-atc]'), sticky = $('[data-atc-sticky]');
      if (!variant) { atc.disabled = true; atc.textContent = 'No disponible'; sticky.disabled = true; return; }
      $('[data-price]').textContent = fmt(variant.price);
      var cmp = $('[data-compare]');
      if (variant.compare_at_price > variant.price) { cmp.hidden = false; cmp.textContent = fmt(variant.compare_at_price); } else { cmp.hidden = true; }
      paintUpsells();
      var r = calc(units());
      if (variant.available) {
        atc.disabled = false; sticky.disabled = false;
        atc.textContent = (r.n > 1 ? 'Añadir las 2 · ' : 'Añadir al carrito · ') + fmt(r.total);
        sticky.textContent = 'Añadir · ' + fmt(r.total);
      } else {
        atc.disabled = true; sticky.disabled = true;
        atc.textContent = 'Agotada en esta graduación'; sticky.textContent = 'Agotada';
      }
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = fmt(variant.price);
      var save = $('[data-save]');
      if (r.disc > 0) save.innerHTML = 'Ahorras <b>' + fmt(r.disc) + '</b> con la 2ª al 50%';
      else if (FREE > 0) {
        var left = FREE - r.total;
        save.innerHTML = left > 0 ? 'Te faltan <b>' + fmt(left) + '</b> para el envío gratis' : '<b>Envío gratis</b> incluido';
      } else save.textContent = '';
      if (variant.featured_media) goTo(variant.featured_media.id);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    /* ---- Galería ---- */
    var track = $('[data-track]');
    function slides() { return $$('.vp__slide'); }
    function goTo(mediaId) {
      var s = slides().find(function (x) { return x.dataset.mediaId === String(mediaId); });
      if (s && track) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    if (track) {
      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          $$('[data-thumb]').forEach(function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
          $$('.vp__dot').forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        }, 60);
      }, { passive: true });
    }
    $$('[data-thumb]').forEach(function (b) { b.addEventListener('click', function () { goTo(b.dataset.thumb); }); });

    root.addEventListener('change', function (e) {
      var fs = e.target.closest('[data-option-index]');
      if (fs) { sel[+fs.dataset.optionIndex] = e.target.value; updateOptions(); resolveUpsells(); render(); }
    });
    $$('[data-upsell]').forEach(function (el) {
      el.addEventListener('click', function () {
        picked = picked === el ? null : el;
        render();
      });
    });

    /* ---- Añadir ---- */
    function add(btn) {
      if (!variant || !variant.available) return;
      var err = $('[data-error]'); err.hidden = true;
      var items = [{ id: variant.id, quantity: 1 }];
      if (picked && !picked.hidden && picked.dataset.variant) items.push({ id: +picked.dataset.variant, quantity: 1 });
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Añadiendo…';
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json(); })
        .then(function (state) {
          btn.disabled = false; btn.textContent = label;
          if (state.status) { err.textContent = state.description || 'No se ha podido añadir. Inténtalo de nuevo.'; err.hidden = false; return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
            state.id = variant.id;
            drawer.renderContents(state);
            picked = null; render();
          } else { window.location.href = rootUrl + 'cart'; }
        })
        .catch(function () { window.location.href = rootUrl + 'cart'; });
    }
    $('[data-atc]').addEventListener('click', function (e) { add(e.currentTarget); });
    $('[data-atc-sticky]').addEventListener('click', function (e) { add(e.currentTarget); });

    var bar = $('[data-sticky]');
    if ('IntersectionObserver' in window && bar) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-atc-sticky]').tabIndex = show ? 0 : -1;
      }).observe($('[data-atc]'));
    }
    updateOptions(); resolveUpsells(); render();
  }
})();
